<template>
    <div class="img-big-wrap">
        <figure>
            <a :href="fullSrc" :data-fancybox="collectionName" :title="title">
                <!--<img class="img-fluid" :src="{//property[@name = 'photo']/value}"/>-->
                <img class="img-fluid" :alt="alt" :src="thumbSrc"/>
            </a>
        </figure>
    </div>
</template>

<script>
  import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'

  export default {
    props: [
      'thumbSrc',
      'fullSrc',
      'collectionName',
      'title',
      'alt',
    ],

    data () {
      return {}
    },
  }
</script>

<style scoped>

</style>